import themes from '../../theming/themes.js';
import React from 'react';
import _TableData from '../../components/Table/TableData.js';
import _TableRow from '../../components/Table/TableRow.js';

var NoDataRow = function NoDataRow(_ref) {
  var message = _ref.message,
    colSpan = _ref.colSpan,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme;
  return /*#__PURE__*/React.createElement(_TableRow, {
    theme: theme
  }, /*#__PURE__*/React.createElement(_TableData, {
    theme: theme,
    colSpan: colSpan
  }, message));
};

export default NoDataRow;
